export const DEFAULT_DURATION = 4000;
export const UNDO_DURATION = 7000;
export const ERROR_DURATION = 8000;
export const initialToastState = { queue: [], nextId: 1 };
export function toastReducer(state, action) {
    switch (action.type) {
        case 'push': {
            const duration = action.duration ??
                (action.undo ? UNDO_DURATION : action.tone === 'error' ? ERROR_DURATION : DEFAULT_DURATION);
            const toast = {
                id: state.nextId,
                tone: action.tone,
                message: action.message,
                duration,
                ...(action.undo ? { undo: action.undo } : {}),
            };
            // A repeat of the toast already showing (a double-click on Save) is noise, not news.
            const current = state.queue[0];
            if (current &&
                current.message === toast.message &&
                current.tone === toast.tone &&
                !toast.undo) {
                return state;
            }
            return { queue: [...state.queue, toast], nextId: state.nextId + 1 };
        }
        case 'dismiss':
            return { ...state, queue: state.queue.filter((t) => t.id !== action.id) };
    }
}
//# sourceMappingURL=toast-state.js.map